import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Public } from '../api.js';

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const [state, setState] = useState('pending');

  useEffect(() => {
    const token = params.get('token');
    if (!token) return setState('error');
    Public.unsubscribe(token).then(() => setState('done')).catch(() => setState('error'));
  }, [params]);

  return (
    <div className="max-w-lg mx-auto mt-20 md:mt-32 px-4 text-center">
      {state === 'pending' && <p className="text-ink-2">Unsubscribing…</p>}
      {state === 'done' && (
        <>
          <div className="eyebrow text-brand mb-3">Confirmed</div>
          <h1 className="font-display text-5xl mb-4">Unsubscribed.</h1>
          <p className="text-ink-2">You won't receive marketing emails from us anymore. Sorry to see you go.</p>
        </>
      )}
      {state === 'error' && (
        <>
          <div className="eyebrow text-danger mb-3">Invalid link</div>
          <h1 className="font-display text-5xl mb-4">Couldn't unsubscribe.</h1>
          <p className="text-ink-2">This link is invalid or expired. Reply to any club email and we'll remove you manually.</p>
        </>
      )}
    </div>
  );
}
